import { combineReducers } from '@reduxjs/toolkit';
import FormReducers from './form';
import ListReducers from './list';
import UsersToExportReducers from './usersToExport';
import UpdateUserActiveStatusBulkReducers from './updateUserActiveStatusBulk/updateUserActiveStatusBulk';
import ConfirmPaymentReducer from './confirmPayment/confirmPayment.slices';
import CreateProUserReducers from '../auth/createProUser.slices';
import { bulkCreationReducer } from './bulkCreation';

const usersReducers = combineReducers({
  form: FormReducers,
  list: ListReducers,
  usersToExport: UsersToExportReducers,
  updateUserActiveStatusBulk: UpdateUserActiveStatusBulkReducers,
  bulkCreation: bulkCreationReducer,
  confirmPayment: ConfirmPaymentReducer,
  createProAccount: CreateProUserReducers
});

export default usersReducers;

export type UsersReducers = ReturnType<typeof usersReducers>
